
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { canPerform } from '../../utils/permissions';
import './NavBar.css';

function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  function toggleTheme() {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  }

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  function toggleMenu() {
    setMenuOpen(!menuOpen);
  }

  function closeMenu() {
    setMenuOpen(false);
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <span className="logo-icon float">📊</span>
          <span className="logo-text">TaalumaERP</span>
        </div>

        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger ${menuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <NavLink 
            to="/dashboard" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Dashboard
          </NavLink>

          <NavLink 
            to="/inventory" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} 
            end
            onClick={closeMenu}
          >
            Inventory
          </NavLink>

          <NavLink 
            to="/inventory/stocks" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Stocks
          </NavLink>

          <NavLink 
            to="/orders" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Orders
          </NavLink>

          <NavLink 
            to="/customers" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Customers
          </NavLink>

          <NavLink 
            to="/warehouses" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Warehouses
          </NavLink>

          {/* ⭐ NEW: Reports Link */}
          {canPerform('users', 'view') && (
            <NavLink 
              to="/reports" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Reports
            </NavLink>
          )}

          {/* Team Management - Admin Only */}
          {canPerform('users', 'view') && (
            <NavLink 
              to="/team" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Team
            </NavLink>
          )}
        </div>

        <div className="navbar-right">
          <button 
            onClick={toggleTheme} 
            className="theme-toggle" 
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          
          <div className="online-indicator">
            <span className="status-dot pulse"></span>
            {navigator.onLine ? 'Online' : 'Offline'}
          </div>
          
          <div className="user-info">
            <span className="user-name">{user?.organization?.name || user?.username || 'User'}</span>
            <div className="user-avatar">
              {(user?.username?.substring(0, 2) || 'U').toUpperCase()}
            </div>
          </div>
          
          <button onClick={handleLogout} className="btn-logout">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
